import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../../../services/battery-monitoring-api/types/battery-monitoring-api';
import { type PieChartItem } from '@/utils/draw-pie-chart';
import { cycledEnergyPerKilometerSegments } from '@/app/config/chart-segments';

const useChartItems = (baseFilteredVehicles: VehicleCycledEnergyRecord[]): PieChartItem[] =>
  useMemo(
    () =>
      cycledEnergyPerKilometerSegments.map((segment, segmentIndex) => ({
        header: segment.getHeader(),
        value: baseFilteredVehicles.filter((vehicle) => segment.filterVehicle({ vehicle })).length,
        color: segment.color,
        segmentIndex,
      })),
    [baseFilteredVehicles],
  );

export default useChartItems;
